import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteIcon from '@material-ui/icons/Delete';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import HomeIcon from '@material-ui/icons/Home';
import DescriptionIcon from '@material-ui/icons/Description';
import AssignmentIcon from '@material-ui/icons/Assignment';
import TableChartIcon from '@material-ui/icons/TableChart';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import BuildIcon from '@material-ui/icons/Build';
import PowerIcon from '@material-ui/icons/Power';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import SettingsIcon from '@material-ui/icons/Settings';
import { Collapse, useMediaQuery } from '@material-ui/core';
import { Dashboard, ExpandLess, ExpandMore } from '@material-ui/icons';
import Header from '../tmlComponents/Header/Header';
import logo from '../images/tata_motors_logo.png'
import Esakha from '../images/esakha.svg'
import MenuIcon from '@material-ui/icons/Menu';
// import Support from "../images/support.svg"
import config from '../config/config';

const drawerWidth = 265;



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    // overflow: 'hidden',     // Prevent resizing
    // whiteSpace: 'nowrap',   // Prevent text wrapping
    // textOverflow: 'ellipsis', // Ellipsis for long text
  },
  listItemText: {
    overflow: 'hidden',      // Ensures ellipsis takes effect
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',    // Prevents wrapping for long text
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    height: '100%',
    display: 'block',
    // overflow:'auto'
    minHeight: '100vh',
    width: `calc(100% - ${drawerWidth}px)`,
  },
  nested: {
    paddingLeft: theme.spacing(4), // Adjust the value as needed for indentation
  },

  mainContentWrapper: {
    padding: theme.spacing(2),
  },
  iconColor: {
    color: '#0275a7',
  },
}));

export default function PersistentDrawerLeft({ children }) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [assetTransferOpen, setAssetTransferOpen] = useState(false);
  const [assetDisposalOpen, setAssetDisposalOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [user, setUserDetails] = useState();
  const [hovered, setHovered] = useState(false); // State for hover behavior
  const [pliOpen, setPliOpen] = useState(false);
  const [assetDeclarationOpen, setAssetDeclarationOpen] = useState(false);
  const [pliVerificationOpen, setPliVerificationOpen] = useState(false);

  const [mobileOpen, setMobileOpen] = useState(false); // State for mobile drawer
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // const handleAssetDeclaration = () => {
  //   setAssetDeclarationOpen(!assetDeclarationOpen);
  // };

  const handlePLIVerificationClick = () => {
    setPliVerificationOpen(!pliVerificationOpen);
  };

  const handlePliClick = () => {
    setPliOpen(!pliOpen);
  };

  // const { keycloak, initialized } = useKeycloak();
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };


  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleDrawerHoverOpen = () => {
    if (!open) setHovered(true); // Only open on hover when it's closed
    setMobileOpen(false);
  };

  const handleDrawerHoverClose = () => {
    if (!open) setHovered(false); // Only close on hover leave when it's closed
  };

  const handleAssetTransferClick = () => {
    setAssetTransferOpen(!assetTransferOpen);
  };

  const handleAssetDisposalClick = () => {
    setAssetDisposalOpen(!assetDisposalOpen); // Toggle Asset Disposal submenu
  };

  const tabs = [
    { text: 'Home', icon: <HomeIcon className={classes.iconColor} />, path: '/' },
    { text: 'Dashboard', icon: <Dashboard className={classes.iconColor} />, path: '/dashboard' },
    { text: 'Asset Master Table', icon: <TableChartIcon className={classes.iconColor} />, path: '/asset-master-table' },

    ...(userRole === "admin" || userRole === 'supplier' || userRole === "asset_transfer" || userRole === "view_only" ? [
      {
        text: 'Asset Transfer', icon: <TransferWithinAStationIcon className={classes.iconColor} />, path: '/asset-transfer', hasSubTabs: true,
        // Only include 'Asset Transfer Request' if userRole is not 'supplier'
        subTabs: [
          ...(userRole !== 'supplier' && userRole !== 'view_only' ? [{ text: 'Asset Transfer Request', path: '/asset-transfer-form' }] : []),
          { text: 'Asset Transfer Table', path: '/asset-transfer-table' }
        ]
      }
    ] : []),


    // // Conditional rendering for 'Asset Disposal' based on userRole
    // ...(userRole === 'admin' ? [{
    //   text: 'Asset Disposal', icon: <DeleteIcon className={classes.iconColor} />, path: '/asset-disposal-req', hasSubTabs: true, subTabs: [
    //     { text: 'Asset Disposal Request', path: '/asset-disposal-req' },
    //     { text: 'Asset Disposal Table', path: '/asset-disposal-table' },
    //   ]
    // }] : []),
    ...(userRole === 'admin' || userRole === 'view_only' || userRole === 'asset_dispose' ? [{
      text: 'Asset Disposal',
      icon: <DeleteIcon className={classes.iconColor} />,
      path: userRole === 'admin' ? '/asset-disposal-req' : '/asset-disposal-table', // Default path based on role
      hasSubTabs: true,
      subTabs: userRole === 'admin' || userRole === 'asset_dispose'
        ? [
          { text: 'Asset Disposal Request', path: '/asset-disposal-req' },
          { text: 'Asset Disposal Table', path: '/asset-disposal-table' },
        ]
        : [
          { text: 'Asset Disposal Table', path: '/asset-disposal-table' }
        ]
    }] : []),
    { text: 'Physical Verification', icon: <VerifiedUserIcon className={classes.iconColor} />, path: '/physical-verification' },
    { text: 'Preventive Maintenance', icon: <SettingsBackupRestoreIcon className={classes.iconColor} />, path: '/preventive-maintenance' },

    ...(userRole === 'admin' || userRole === 'supplier' ? [{ text: 'Report Breakdown', icon: <PowerIcon className={classes.iconColor} />, path: '/report-breakdown/select-asset' }] : []),




    { text: 'Breakdown Management', icon: <BuildIcon className={classes.iconColor} />, path: '/breakdown-management' },
    // { text: 'PLI Physical Verification', icon: <DescriptionIcon className={classes.iconColor} />, path: '/pli/select-asset' },

    {
      text: 'PLI Physical Verification', icon: <DescriptionIcon className={classes.iconColor} />, path: '', hasSubTabs: true, subTabs: [
        ...(userRole === 'admin' || userRole === 'supplier' ? [{ text: 'PLI Form', path: '/pli/select-asset' }] : []),
        { text: 'PLI PV History', path: '/pli-table' },
      ]
    },

    {
      text: 'PLI Asset Declaration', icon: <AssignmentIcon className={classes.iconColor} />, path: '', hasSubTabs: true, subTabs: [
        ...(userRole === 'admin' || userRole === 'supplier' ? [{ text: 'Upload Declaration', path: '/upload-asset-declaration' }] : []),
        {
          text: 'PLI AD History',
          path: userRole === 'supplier' ? '/asset-declaration-history' : '/asset-declaration/vendor-list'
        },
      ]
    },

    // Conditional rendering for 'Asset Disposal' based on userRole
    ...(userRole === 'admin' ? [{ text: 'Settings', icon: <SettingsIcon className={classes.iconColor} />, path: '/settings' }] : []),

    { text: 'Support', icon: <HelpOutlineIcon className={classes.iconColor} />, path: '/support' },

  ];
  
  const handleLoginLogout = () => {
    if (window.keycloak.authenticated) {
      window.keycloak.logout();
      setLoggedIn(true);
    } else {
      window.keycloak.login()
    }

  }

  useEffect(() => {
    if (window.keycloak.authenticated) {
      setLoggedIn(true);
      // Fetch user information from Keycloak
      const userDetails = window.keycloak.tokenParsed;
      setUserDetails(userDetails)
      console.log("userDetails", userDetails)
      if (userDetails) {
        setUserName(userDetails.name || userDetails.preferred_username || 'User');
        localStorage.setItem("username", userDetails.name)
      }
      // Extract vendor code from user-groups
      const vendorGroup = userDetails["user-groups"]?.find(group => group.startsWith("/Vendors/"));
      if (vendorGroup) {
        const vendorCode = vendorGroup.split("/")[2]; // Extract the vendor code (J64938)
        localStorage.setItem("vendorCode", vendorCode); // Store vendor code in localStorage
        console.log("Vendor Code:", vendorCode);
      }
      // Extract role from asset_management_functions
      const role = userDetails.asset_management_functions?.[0]; // Assuming you want the first role
      if (role) {
        const lowerCaseRole = role?.toLowerCase(); // Convert role to lowercase
        setUserRole(lowerCaseRole)
        localStorage.setItem("userRole", lowerCaseRole); // Store the role in localStorage
        console.log("User Role:-------------------", lowerCaseRole);
      }

    }
  }, []);



  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* AppBar with Menu Button */}
      {/* <div className={clsx(classes.appBar)}>
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" noWrap>
          Your App Title
        </Typography>
      </div> */}

      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        anchor="left"
        open={open}
        onClose={handleDrawerToggle}
        // variant="permanent"
        // anchor="left"
        // open={open}
        onMouseEnter={handleDrawerHoverOpen} // Open drawer on hover
        onMouseLeave={handleDrawerHoverClose} // Close drawer when hover leaves
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open || hovered, // Opens drawer on hover
          [classes.drawerClose]: !open && !hovered, // Closes when not hovered or manually closed
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open || hovered,
            [classes.drawerClose]: !open && !hovered,
          }),
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            {/* <img src='/favicon-32x32.png' alt='LOGO' width={28} /> */}
          </IconButton>
        </div>
        <Divider />
        <List>
          {tabs.map((tab, index) => (
            tab.hasSubTabs ? (
              <React.Fragment key={tab.text}>
                <ListItem button onClick={() => {
                  if (tab.text === 'Asset Transfer') handleAssetTransferClick();
                  if (tab.text === 'Asset Disposal') handleAssetDisposalClick();
                  if (tab.text === 'PLI Asset Declaration') handlePliClick();
                  if (tab.text === 'PLI Physical Verification') handlePLIVerificationClick();
                }}>
                  <ListItemIcon>{tab.icon}</ListItemIcon>
                  <ListItemText primary={tab.text}
                    classes={{ primary: classes.listItemText }} // Apply text overflow style
                  />
                  {/* {tab.text === 'Asset Transfer'
                    ? (assetTransferOpen ? <ExpandLess /> : <ExpandMore />)
                    : tab.text === 'Asset Disposal'
                      ? (assetDisposalOpen ? <ExpandLess /> : <ExpandMore />)
                      : tab.text === 'PLI Declaration'
                        ? (pliOpen ? <ExpandLess /> : <ExpandMore />)
                        : tab.text === 'PLI Physical Verification'
                          ? (pliVerificationOpen ? <ExpandLess /> : <ExpandMore />) // Add this condition
                          : (assetDeclarationOpen ? <ExpandLess /> : <ExpandMore />)
                  } */}
                  {tab.text === 'Asset Transfer'
                    ? (assetTransferOpen ? <ExpandLess /> : <ExpandMore />)
                    : tab.text === 'Asset Disposal'
                      ? (assetDisposalOpen ? <ExpandLess /> : <ExpandMore />)
                      : tab.text === 'PLI Asset Declaration'
                        ? (pliOpen ? <ExpandLess /> : <ExpandMore />)
                        : tab.text === 'PLI Physical Verification'
                          ? (pliVerificationOpen ? <ExpandLess /> : <ExpandMore />)
                          : <ExpandMore /> // Default to ExpandMore for tabs without an open/close state
                  }

                </ListItem>

                <Collapse in={tab.text === 'Asset Transfer' ? assetTransferOpen : tab.text === 'Asset Disposal' ? assetDisposalOpen : tab.text === 'PLI Asset Declaration' ? pliOpen : tab.text === 'PLI Physical Verification' ? pliVerificationOpen : assetDeclarationOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {tab.subTabs.map((subTab, subIndex) => (
                      <ListItem
                        button
                        key={subTab.text}
                        component={Link}
                        to={subTab.path}
                        className={classes.nested}
                      >
                        <ListItemText primary={subTab.text}
                          classes={{ primary: classes.listItemText }} // Apply text overflow style
                        />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </React.Fragment>
            ) : (
              <ListItem button component={Link} to={tab.path} key={tab.text}>
                <ListItemIcon>{tab.icon}</ListItemIcon>
                <ListItemText primary={tab.text} />
              </ListItem>
            )
          ))}

        </List>
        <Divider />
      </Drawer>


      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <div style={{ position: "sticky", top: "0", zIndex: "1000" }}>
          <Header
            images={{ logo, Esakha }}
            config={config}
            other={{ alt: 'Tata Motors' }}
            logoutUser={handleLoginLogout}
            user={user}
            backArrowButton={isMobile ? <MenuIcon /> : null}
            handleDrawerToggle={handleDrawerOpen}
            isMobile={isMobile}
          />
        </div>

        <div className={classes.mainContentWrapper}>
          {children}
        </div>

        {/* <div className={classes.drawerHeader} /> */}
      </main>
    </div>
  );
}


